import { ServicoToast } from './ServicoToast'

/**
 * Plugin Vue que disponibiliza this.$toast em todos os componentes.
 *
 * Instale em main.ts:
 *   app.use(ToastPlugin)
 *
 * Monte o container uma vez em App.vue:
 *   <PToaster />
 *
 * Uso nos componentes:
 *   this.$toast.sucesso('Salvo!')
 *   this.$toast.erro('Erro ao carregar dados.')
 *   this.$toast.alerta('Divergência encontrada.')
 *   this.$toast.info('Sincronizando...')
 */

/* eslint-disable @typescript-eslint/no-explicit-any */
export const ToastPlugin = {
  install(app: any): void {
    app.config.globalProperties.$toast = ServicoToast
  },
}
/* eslint-enable @typescript-eslint/no-explicit-any */
